import React, { Component } from 'react';
import { connect } from "react-redux";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip, Card, Alert, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import DataTable from "../../components/Table/Table";
import "react-table/react-table.css";
import { Link } from "react-router-dom";
import { getAutoScaleConfigs, deleteAutoScaleConfig, setAutoScalePageInfo, updateAutoScaleConfig } from "../../actions/actionAutoScale";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import "react-select/dist/react-select.css";


class AutoScale extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            filterId: null,
            autoscalesModal: false,
            selectedAutoScaleConfigs: [],
        };

        this.cancelDelete = this.cancelDelete.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteBrandingAction = this.deleteBrandingAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
        this.assignAutoScaleConfigs = this.assignAutoScaleConfigs.bind(this);
        this.cancelAutoScaleConfigsModal = this.cancelAutoScaleConfigsModal.bind(this);
        this.handleChangeAutoScaleConfigs = this.handleChangeAutoScaleConfigs.bind(this);

    }

    componentDidMount() {
        this.props.getAutoScaleConfigs();
    }

    handleChangeAutoScaleConfigs(selectedAutoScaleConfigs) {
        this.setState({ selectedAutoScaleConfigs });
    }

    deleteConfirm(autoscaleConfigId) {
        this.setState({
            modal: !this.state.modal,
            autoscaleConfigId: autoscaleConfigId
        });
    }

    cancelDelete() {
        this.setState({ modal: !this.state.modal });
    }

    cancelAutoScaleConfigsModal() {
        this.setState({ autoscalesModal: !this.state.autoscalesModal });
    }

    deleteBrandingAction() {
        this.props.deleteAutoScaleConfig(this.state.autoscaleConfigId).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }

    async assignAutoScaleConfigs() {
        await Promise.all(this.state.selectedAutoScaleConfigs.map(async autoscale => {
            const autoscaleToUpdate = this.props.autoscale_configs.find(all => all.autoscale_config_id === autoscale.value)
            autoscaleToUpdate.server_pool_id = this.props.pool
            await this.props.updateAutoScaleConfig(autoscaleToUpdate)
        }))

        this.props.getAutoScaleConfigs()
        this.setState({ selectedAutoScaleConfigs: [], autoscalesModal: false });
    }

    handleDeleteSuccess() {
        const { deleteBrandingErrorMessage } = this.props;
        if (deleteBrandingErrorMessage) {
            NotificationManager.error(deleteBrandingErrorMessage, "Delete AutoScale Config Failed", 3000);
        } else {
            NotificationManager.success("Successfully Deleted AutoScale Config", "Delete AutoScale Config", 3000);
            this.setState({ modal: false });
            this.props.getAutoScaleConfigs();
        }
    }

    handleDeleteError() {
        const { deleteBrandingError } = this.props;
        if (deleteBrandingError) {
            NotificationManager.error(deleteBrandingError, "Failed to Delete AutoScale Config", 3000);
            this.props.history.push("/autoscale");
        } else {
            NotificationManager.error("Failed to Delete AutoScale Config", "Delete AutoScale Config", 3000);
            this.props.history.push("/autoscale");
        }
    }

    render() {
        if (this.props.getAutoScaleLoading) {
            return (<div> <LoadingSpinner /></div>);
        }

        const { autoscale_configs, license_info } = this.props;
        let filtered_autoscale_configs = [];
        let unattached_autoscale = []

        if (this.props.pool) {
            filtered_autoscale_configs = autoscale_configs.filter(config => config.server_pool_id === this.props.pool)
            unattached_autoscale = autoscale_configs.filter(config => config.server_pool_id !== this.props.pool && config.autoscale_type === this.props.serverPoolType)
        } else {
            filtered_autoscale_configs = autoscale_configs
            unattached_autoscale = autoscale_configs
        }

        let optionsAutoScaleConfigs = [];
        unattached_autoscale.map(opt => {
            optionsAutoScaleConfigs.push({ label: opt.autoscale_config_name, value: opt.autoscale_config_id });
        });


        const tableColumns = [
            {
                type: "text",
                name: "Name",
                accessor: "autoscale_config_name",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                name: "Type",
                accessor: "autoscale_type",
                filterable: true,
                sortable: true,
            },
            {
                type: "flag",
                name: "Enabled",
                accessor: "enabled",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                name: "Zone",
                accessor: "zone_name",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                name: "Provider",
                accessor: "vm_provider_config.vm_provider_display_name",
                filterable: true,
                sortable: true,
            }
        ];

        const actions = [
            { id: "view", icon: "fa-eye", description: "View" },
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "clone", icon: "fa-clone", description: "Clone" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const haspool = (this.props.pool) ? 'pool=' + this.props.pool : ''
        const create_link = {
            pathname: "/create_autoscale"
        }
        create_link.search = haspool


        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/view_autoscale/${item.autoscale_config_id}`);
                    break;

                case "edit":
                    this.props.history.push(`/update_autoscale/${item.autoscale_config_id}?${haspool}`);
                    break;

                case "clone":
                    this.props.history.push(`/create_autoscale?clone=${item.autoscale_config_id}&${haspool}`);
                    break;

                case "delete":
                    this.deleteConfirm(item.autoscale_config_id);
                    break;
            }
        }
        let license_url = `${__LICENSE_INFO_URL__}`;
        return (
            <div className="profile-page">
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                                <div className="title-head">
                                    <Link className='tw-text-color' to={{ pathname: "/autoscale" }}><i className="fa fa-balance-scale"></i> <strong>AutoScale Configurations</strong></Link></div>
                                {license_info && license_info.status && license_info.status.features && license_info.status.features.indexOf('auto_scaling') >= 0 && (
                                    <Row>
                                        <Col>
                                            <Link className="pull-right add-btn" to={create_link}>
                                                <button className="pull-right adduser-btn" size="sm" color="dark">
                                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                                    Add
                                                </button>
                                            </Link>
                                            {this.props.pool && (
                                                <div className="pull-right add-btn tw-mr-3">
                                                    <button onClick={() => this.setState({ autoscalesModal: true })} className="pull-right adduser-btn !tw-bg-[#181f471a] tw-text-color dark:!tw-bg-[#363d5d] dark:tw-text-white" size="sm" color="dark">
                                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                                        Assign
                                                    </button>
                                                </div>

                                            )}
                                        </Col>
                                    </Row>
                                )}
                            </CardHeader>
                            {license_info && license_info.status && license_info.status.features && license_info.status.features.indexOf('auto_scaling') >= 0 ? (
                            <CardBody className="p-0">
                                <DataTable
                                    id="autoscale"
                                    data={filtered_autoscale_configs}
                                    columns={tableColumns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                            ) :  (
                              <Alert color="none" isOpen={true}>
                                <h4>Unavailable</h4>
                                This feature must be licensed.
                                <hr />
                                <a href={license_url}>More Information</a><br />
                              </Alert>)}
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.autoscalesModal} toggle={this.cancelAutoScaleConfigsModal} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelAutoScaleConfigsModal}>Assign Existing AutoScale Config(s) To This Pool.
                    </ModalHeader>
                    <ModalBody>

                        <Select
                            name="autoscales"
                            multi={true}
                            options={optionsAutoScaleConfigs}
                            value={this.state.selectedAutoScaleConfigs}
                            onChange={this.handleChangeAutoScaleConfigs}
                        />


                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.cancelAutoScaleConfigsModal}
                            className="cancel-button"
                            size="sm" color="basic"> Close</Button>
                        <Button onClick={this.assignAutoScaleConfigs}
                            className="submit-button"
                            size="sm" color="success"> Assign</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this config?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} size="sm"
                            className="cancel-button"
                            color=" basic">Close</Button>
                        <Button onClick={this.deleteBrandingAction}
                            className="delete-button"
                            size="sm" color="danger">Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

let AutoScaleWithRouter = withRouter(AutoScale);

export default connect(state => ({
    autoscale_configs: state.autoscale.autoscale_configs || [],
    getAutoScaleLoading: state.autoscale.getAutoScaleLoading || false,
    getBrandingErrorMessage: state.autoscale.getBrandingErrorMessage || false,
    getBrandingError: state.autoscale.getBrandingError || null,
    deleteBrandingErrorMessage: state.autoscale.deleteBrandingErrorMessage || null,
    deleteBrandingError: state.autoscale.deleteBrandingError || null,
    deletedBranding: state.autoscale.deletedBranding || null,
    deleteBrandingLoading: state.autoscale.deleteBrandingLoading || null,
    pages: { pageSize: state.autoscale.pageSize, pageNo: state.autoscale.pageNo },
    license_info: state.footer && state.footer.license_info ? state.footer.license_info : null,
}),
    dispatch => ({
        getAutoScaleConfigs: () => dispatch(getAutoScaleConfigs()),
        updateAutoScaleConfig: (data) => dispatch(updateAutoScaleConfig(data)),
        deleteAutoScaleConfig: (data) => dispatch(deleteAutoScaleConfig(data)),
        setPageInfo: (data) => dispatch(setBrandingPageInfo(data)),
    }))(AutoScaleWithRouter);
